module.exports = __webpack_public_path__ + "static/media/XV.345a115f.jpg";